import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import Swal from "sweetalert2";

import { jwtDecode } from 'jwt-decode';
import { EncryptionService } from 'src/app/services/encryption.service';
import { OrganizerSessionService } from 'src/app/services/organizer-session.service';


@Component({
  selector: 'app-platform-legal-organizer',
  templateUrl: './platform-legal-organizer.component.html',
  styleUrls: ['./platform-legal-organizer.component.scss']
})
export class PlatformLegalOrganizerComponent implements OnInit {

  companyForm!: FormGroup;
  organizeID!: { organizer_id: string | number | null };
  Ttoken: any;
  selectedFileName: string | null = null;
  decryptedFileData: any = []
  encryptOrgID: any
  public formfillNext: boolean = false;
  // organizeID={}

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _ds: DataService,
    private route: ActivatedRoute,
    private enc: EncryptionService,
    private organizerSession: OrganizerSessionService
  ) { }

  ngOnInit(): void {
    // this.route.queryParamMap.subscribe(params => {
    //   const token = params.get('token');
    //   this.Ttoken = params.get('token');
    //   if (!token) return;
    //   const decoded = jwtDecode<OrganizerApprovalPayload>(token);
    //   console.log('FULL TOKEN 👉', decoded);
    //   this.organizer = decoded.organizer;
    //   console.log('Company 👉', this.organizer.id);
    // });

    // this.companyForm = this.fb.group({
    //   accountName: ['', Validators.required],

    //   accountNumber: [
    //     '',
    //     [Validators.required, Validators.pattern(/^[0-9]{9,18}$/)]
    //   ],

    //   ifscCode: [
    //     '',
    //     [Validators.required, Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/)]
    //   ],

    //   bankName: ['', Validators.required],
    //   branchName: ['', Validators.required],


    //   filecheque: [null, Validators.required]
    // });

    this.companyForm = this.fb.group({
      accountName: [''],
      accountNumber: [''],
      ifscCode: [''],
      bankName: [''],
      branchName: [''],
      filecheque: [null]
    });

    this.route.queryParams.subscribe(params => {
      const id = this.organizerSession.validateRouteOrganizerId(
        params['id'],
        '/platform-legal-organizer',
        this.router
      );
      if (id == null) return;

      this._ds.getUniqueUserData(id).subscribe((res: any) => {
        const allData = this.enc.decrypt(res.data);
        console.log(allData)
        if (allData.bank_details_exists == true) {
          this.formfillNext = true
          Object.keys(this.companyForm.controls).forEach(key => {
            this.companyForm.get(key)?.disable();
          });

          setTimeout(() => {
            this.companyForm.patchValue({
              accountName: allData.bank_details.account_holder_name,
              accountNumber: allData.bank_details.account_number,
              branchName: allData.bank_details.branch_name,
              bankName: allData.bank_details.bank_name,
              ifscCode: allData.bank_details.ifsc_code,
              eventsPerYear: allData.organizer.events_per_year_range
            });
            this.selectedFileName = allData.bank_details.cheque_info

          }, 500);

        } else {
          this.formfillNext = false

        }
      });
    });

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    if (organizer?.id) {
      this.organizeID = { organizer_id: organizer.id };
    } else if (user?.organizer.id) {
      this.organizeID = { organizer_id: user.organizer.id };
    } else {
      this.organizeID = { organizer_id: null };
    }


  }

  submit() {
    this._ds.getDataOrganizerId(this.organizeID).subscribe({
      next: (res: any) => {
        this.encryptOrgID = this.enc.decrypt(res.data);

        const payload = {
          account_holder_name: this.companyForm.value.accountName || '',
          account_number: this.companyForm.value.accountNumber || '',
          ifsc_code: this.companyForm.value.ifscCode || '',
          bank_name: this.companyForm.value.bankName || '',
          branch_name: this.companyForm.value.branchName || '',
          cheque_file: this.decryptedFileData?.url || ''
        };

        this._ds.submitBankDetails(this.encryptOrgID.url_safe_organizer_id, payload).subscribe({
          next: (res: any) => {
            if (res?.data) {
              const decryptedData = this.enc.decrypt(res.data);
              localStorage.setItem('pdf_download', JSON.stringify(decryptedData.agreement_url));
              const id = this.organizerSession.getSessionOrganizerId();
              if (id != null) {
                this.router.navigate(['/agreement'], { queryParams: { id } });
              }
            }
          },
          error: (err) => {
            if (err?.error?.data) {
              const decryptedData = this.enc.decrypt(err.error.data);
              Swal.fire({
                toast: true,
                position: 'top',
                timer: 2000,
                showConfirmButton: false,
                icon: 'error',
                title: decryptedData.error
              });
            }
          }
        });
      }
    });
  }


  skip() {
    this.router.navigate(['/agreement'], {
      // queryParams: {
      //   token: this.Ttoken   // ya jo bhi variable me token hai
      // }
    });
  }

  next() {
    const id = this.organizerSession.getSessionOrganizerId();
    if (id == null) return;
    this.router.navigate(['/agreement'], { queryParams: { id } });
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  onIfscInput(event: Event) {
    const input = event.target as HTMLInputElement | null;
    if (!input) return;

    const value = input.value.toUpperCase();
    this.companyForm.get('ifscCode')?.setValue(value, { emitEvent: false });
  }

  onFileSelect(event: any): void {
    const file = event.target.files?.[0];
    const control = this.companyForm.get('filecheque');
    if (!control || !file) return;   // 🔥 file null safety

    const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      control.setErrors({ invalidType: true });
      control.markAsTouched();
      this.selectedFileName = '';
      event.target.value = '';       // input clear
      return;
    }

    // ✅ Max size: 3MB
    const maxSize = 3 * 1024 * 1024; // 3MB
    if (file.size > maxSize) {
      control.setErrors({ maxSize: true });
      control.markAsTouched();
      this.selectedFileName = '';
      event.target.value = '';       // input clear (allowed)
      return;
    }

    this.selectedFileName = file.name;

    // ✅ Sirf FormControl me set karo (DOM input ko mat chhedo)
    control.setValue(file);
    control.updateValueAndValidity();
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizerId =
      organizer?.id
        ? organizer.id
        : user?.organizer?.id
          ? user.organizer.id
          : null;

          const firstName =
  organizer?.first_name
    ? organizer.first_name
    : user?.organizer?.first_name
      ? user.organizer.first_name
      : null;

const lastName =
  organizer?.last_name
    ? organizer.last_name
    : user?.organizer?.last_name
      ? user.organizer.last_name
      : null;

    const formData = new FormData();
    formData.append('organizer_name', firstName + ' ' + lastName);
    formData.append('organizer_id', organizerId);
    formData.append('kyc_type', 'cheque');
    formData.append('file', file);

    this._ds.uploadDoucment(formData).subscribe({
      next: (res: any) => {
        if (res?.data && typeof res.data === 'string') {
          this.decryptedFileData = this.enc.decrypt(res.data);
        }
      },
      error: (err) => {
        console.log('Upload error:', err);
        control.setErrors({ uploadFailed: true });   // 🔥 optional: error state
      }
    });
  }

  triggerFile() {
    const fileInput = document.getElementById('panFile') as HTMLElement;
    fileInput.click();
  }

  back() {
    // this.router.navigate(['/event-information']); 
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    // 🔥 pehle user.organizer se try karo
    const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
    const orgId = user?.organizer?.id || organizer?.id;

    if (!orgType || !orgId) {
      console.error('❌ Organizer data missing in both user & organizer');
      return;
    }
    this.router.navigate(['/platform-legal'], { queryParams: { id: orgId } });

  }

}
